export const msu = {
    agencyCode: '735',
    name: 'Midwestern State University',
    shortName: 'MSU',
    slug: 'msu'
    
    
  };